<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="供应商下单" name="first">
                <swb-device-require-voucher-voucher :voucherIds="voucherIds"></swb-device-require-voucher-voucher>
            </el-tab-pane>
            <el-tab-pane label="拆分下单" name="second">
                <swb-device-require-voucher-split-order :itemFilter="itemFilter" :voucherIds="voucherIds" :lowCostFlag="lowCostFlag" ref="swb_device_require_voucher_split_order"></swb-device-require-voucher-split-order>
            </el-tab-pane>
            <el-tab-pane label="其他供应商" name="third">
                <swb-device-require-voucher-other-vendor :itemFilter="itemFilter" :lowCostFlag="lowCostFlag" ref="swb_device_require_voucher_other_vendor"></swb-device-require-voucher-other-vendor>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import SwbDeviceRequireVoucherVoucher from  './DeviceRequireVoucherVoucher.vue'
    Vue.regist(SwbDeviceRequireVoucherVoucher);
    import SwbDeviceRequireVoucherOtherVoucher from  './DeviceRequireVoucherOtherVoucher.vue'
    Vue.regist(SwbDeviceRequireVoucherOtherVoucher);
    import SwbDeviceRequireVoucherSplitOrder from  './DeviceRequireVoucherSplitOrder.vue'
    Vue.regist(SwbDeviceRequireVoucherSplitOrder);
    //
    export default {
        name: 'swb-require-goods-item-statis',
        desc: '配货单新增',
        props: {
            voucherIds: {
                type: Array,
                default: null
            },
            lowCostFlag: { // 选择耗材信息
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                activeName: 'first',
                itemFilter: {
                    goodsItemList: [],
                    asmblItemList: [],
                },
                goodsItemList: [],
                asmblItemList: [],
                requireGoodsAsmblItemList: [],
                requireGoodsItemList: [],
                //
                event: {},
                thirdFlag: false,
            }
        },
        created: function () {
        },
        methods: {
            handleClick(tab, event) {
                let self = this;
                let itemFilter = self.itemFilter || {};
                let activeName = self.activeName;
                if(activeName == "third") {
                    self.thirdFlag = true;
                    let result = self.$refs.swb_device_require_voucher_split_order.getDlgResult() || {};
                    let postData = result.data;
                    itemFilter = {
                        goodsItemList: postData.goodsItemList,
                        asmblItemList: postData.asmblItemList
                    };
                    self.requireGoodsAsmblItemList = Utils.merge([], postData.requireGoodsAsmblItemList);
                    self.requireGoodsItemList = Utils.merge([], postData.requireGoodsItemList);
                    self.itemFilter = Utils.merge([], itemFilter);
                } else {
                    let otherResult = self.$refs.swb_device_require_voucher_other_vendor.getDlgResult() || {};
                    let otherPostData = otherResult.data;
                    itemFilter = {
                        goodsItemList: otherPostData.goodsItemList,
                        asmblItemList: otherPostData.asmblItemList
                    };
                    self.itemFilter = Utils.merge({}, itemFilter);
                }
            },
            getDlgResult: function () {
                let orderResult = this.$refs.swb_device_require_voucher_split_order.getDlgResult() || {};
                let postData = orderResult.data;
                let requireGoodsAsmblItemList = Utils.merge([], postData.requireGoodsAsmblItemList);
                let requireGoodsItemList = Utils.merge([], postData.requireGoodsItemList);
                let goodsItemList = postData.goodsItemList;
                let asmblItemList = postData.asmblItemList;
                let goodsAsmblItemMap = {};
                if(requireGoodsAsmblItemList.length > 0) {
                    for(let i = 0; i < requireGoodsAsmblItemList.length; i++) {
                        let requireGoodsAsmblItem = requireGoodsAsmblItemList[i];
                        let goodsItemId = requireGoodsAsmblItem.goodsItemId;
                        if(Utils.isNoB(goodsAsmblItemMap[goodsItemId])) {
                            let goodsAsmblItemList = [];
                            goodsAsmblItemList.push(requireGoodsAsmblItem);
                            goodsAsmblItemMap[goodsItemId] = goodsAsmblItemList;
                        } else {
                            let goodsAsmblItems = goodsAsmblItemMap[goodsItemId] || [];
                            goodsAsmblItems.push(requireGoodsAsmblItem);
                            goodsAsmblItemMap[goodsItemId] = goodsAsmblItems;
                        }
                    }
                }
                let goodsItemMap = {};
                let voucherIds = [];
                if(requireGoodsItemList.length > 0) {
                    for(let i = 0; i < requireGoodsItemList.length; i++) {
                        let requireGoodsItem = requireGoodsItemList[i];
                        let voucherId = requireGoodsItem.voucherId;
                        if(Utils.isNoB(goodsItemMap[voucherId])) {
                            voucherIds.push(voucherId);
                            let goodsItemList = [];
                            goodsItemList.push(requireGoodsItem);
                            goodsItemMap[voucherId] = goodsItemList;
                        } else {
                            let goodsItems = goodsItemMap[voucherId] || [];
                            goodsItems.push(requireGoodsItem);
                            goodsItemMap[voucherId] = goodsItems;
                        }
                    }
                }
                let otherPostData = null;
                if(this.thirdFlag) {
                    let otherResult = this.$refs.swb_device_require_voucher_other_vendor.getDlgResult() || {};
                    otherPostData = otherResult.data;
                    goodsItemList = otherPostData.goodsItemList;
                    asmblItemList = otherPostData.asmblItemList;
                }

                //
                let doSave = true;
                if(!Utils.isNoB(goodsItemList)) {
                    for(let i = 0; i < goodsItemList.length; i++) {
                        let goodsItem = goodsItemList[i];
                        let itemList = goodsItem.itemList || [];
                        if(itemList.length > 0) {
                            for(let j = 0; j < itemList.length; j++) {
                                let item = itemList[j];
                                if(Utils.isNoB(item.skuId)) {
                                    doSave = false;
                                    break;
                                }
                            }
                        }
                        let goodsitems = goodsItemMap[goodsItem.voucherId] || [];
                        goodsitems.push(goodsItem);
                        goodsItemMap[goodsItem.voucherId] = goodsitems;
                    }
                }
                //
                if(!Utils.isNoB(asmblItemList)) {
                    for(let i = 0; i < asmblItemList.length; i++) {
                        let asmblItem = asmblItemList[i];
                        if(Utils.isNoB(asmblItem.skuId)) {
                            doSave = false;
                            break;
                        }
                        let asmblItems = goodsAsmblItemMap[asmblItem.goodsItemId] || [];
                        asmblItems.push(asmblItem);
                        goodsAsmblItemMap[asmblItem.goodsItemId] = asmblItems;
                    }
                }
                //
                let result = {};
                if(Utils.isTrue(doSave)) {
                    let deviceRequireVoucherList = [];
                    for(let i = 0; i < voucherIds.length; i++) {
                        let deviceRequireVoucher = {};
                        let voucherId = voucherIds[i];
                        let itemList = goodsItemMap[voucherId];
                        for(let j = 0; j < itemList.length; j++) {
                            let item = itemList[j];
                            if(!Utils.isNoB(item.id)) {
                                item.itemList = goodsAsmblItemMap[item.id];
                            }
                        }
                        deviceRequireVoucher.id = voucherId;
                        deviceRequireVoucher.goodsItemList = itemList;
                        deviceRequireVoucherList.push(deviceRequireVoucher);
                    }
                    result.type = "info";
                    result.data = deviceRequireVoucherList;
                } else {
                    result.type = "warn";
                    result.message = "所选组装件没有关联商品";
                }
                return result;

            }
        }
    }
</script>

<style>
    .el-collapse-item .el-collapse-item__header {
        background: aliceblue;
    }

    .el-tabs__content {
        padding: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/compo/retailer/RequireGoodsItemStatis.vue